import Conversation from "../../../models/conversation/Conversation";

export const groupConversationsByDate = (
  conversations: Conversation[]
): { [key: string]: Conversation[] } => {
  const groups: { [key: string]: Conversation[] } = {};

  const sortedConversations = [...conversations].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  sortedConversations.forEach((conversation) => {
    const updatedAt = new Date(conversation.updatedAt);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const daysDifference = Math.floor(
      (today.getTime() - updatedAt.getTime()) / (1000 * 60 * 60 * 24)
    );
    const monthsDifference =
      today.getMonth() -
      updatedAt.getMonth() +
      12 * (today.getFullYear() - updatedAt.getFullYear());

    if (daysDifference <= 7) {
      groups["Sidste 7 dage"] = groups["Sidste 7 dage"] || [];
      groups["Sidste 7 dage"].push(conversation);
    } else if (daysDifference <= 30) {
      groups["Sidste 30 dage"] = groups["Sidste 30 dage"] || [];
      groups["Sidste 30 dage"].push(conversation);
    } else {
      const monthKey = `${monthsDifference} ${monthsDifference === 1 ? "måned" : "måneder"} siden`;
      groups[monthKey] = groups[monthKey] || [];
      groups[monthKey].push(conversation);
    }
  });

  return groups;
};
